import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { FEATURES } from "../../mock/mockData";

export default function Features() {
  return (
    <section className="py-24 bg-brand-softer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <p className="text-brand-limeDark font-semibold mb-3">La solution 360immoinvest</p>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold text-brand-greenDeep">
            Tout ce qu'il faut pour gérer, au même endroit
          </h2>
          <p className="mt-4 text-lg text-brand-green/60">
            Encaissez sereinement, restez en règle, gardez la main sur vos comptes et gagnez du temps. Vos documents se génèrent automatiquement chaque mois.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f) => {
            const Icon = Icons[f.icon] || Icons.Circle;
            return (
              <div
                key={f.title}
                className="group bg-white rounded-2xl p-7 border border-brand-soft hover:border-brand-lime hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <span className="w-12 h-12 rounded-xl bg-brand-soft group-hover:bg-brand-lime flex items-center justify-center transition-colors mb-5">
                  <Icon className="w-6 h-6 text-brand-green group-hover:text-brand-greenDeep" strokeWidth={2} />
                </span>
                <h3 className="font-semibold text-lg text-brand-greenDeep mb-2">{f.title}</h3>
                <p className="text-brand-green/60 text-sm leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 rounded-3xl bg-brand-greenDeep text-white p-7 sm:p-9 flex flex-col sm:flex-row sm:items-center gap-6" data-testid="home-lmnp-banner">
          <span className="w-14 h-14 rounded-2xl bg-brand-lime text-brand-greenDeep flex items-center justify-center flex-shrink-0">
            <Icons.TrendingUp className="w-7 h-7" strokeWidth={2} />
          </span>
          <div className="flex-1">
            <p className="text-xs font-semibold text-brand-lime uppercase tracking-wide mb-1">Nouveau · Projet de loi de finances 2027</p>
            <h3 className="font-display text-2xl font-semibold">LMNP : combien le budget 2027 pourrait vous coûter ?</h3>
            <p className="text-white/70 text-sm mt-1">Estimez en 1 minute l'impact du plafonnement de l'amortissement sur votre impôt. Gratuit, sans inscription.</p>
          </div>
          <Link
            to="/simulateur-lmnp-2027"
            className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep font-semibold transition-colors flex-shrink-0"
            data-testid="home-lmnp-cta"
          >
            Simuler mon impact
            <Icons.ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>

        <div className="mt-4 rounded-3xl bg-white border border-brand-soft p-7 sm:p-9 flex flex-col sm:flex-row sm:items-center gap-6" data-testid="home-quittance-banner">
          <span className="w-14 h-14 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center flex-shrink-0">
            <Icons.FileText className="w-7 h-7" strokeWidth={2} />
          </span>
          <div className="flex-1">
            <p className="text-xs font-semibold text-brand-limeDark uppercase tracking-wide mb-1">Outil gratuit · sans inscription</p>
            <h3 className="font-display text-2xl font-semibold text-brand-greenDeep">Générez une quittance de loyer en quelques clics</h3>
            <p className="text-brand-green/60 text-sm mt-1">Remplissez, imprimez ou enregistrez en PDF. Vos données restent sur votre appareil.</p>
          </div>
          <Link
            to="/quittance-de-loyer/generateur"
            className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold transition-colors flex-shrink-0"
            data-testid="home-quittance-cta"
          >
            Générer ma quittance
            <Icons.ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>

        <div className="mt-4 rounded-3xl bg-white border border-brand-soft p-7 sm:p-9 flex flex-col sm:flex-row sm:items-center gap-6" data-testid="home-irl-banner">
          <span className="w-14 h-14 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center flex-shrink-0">
            <Icons.Calculator className="w-7 h-7" strokeWidth={2} />
          </span>
          <div className="flex-1">
            <p className="text-xs font-semibold text-brand-limeDark uppercase tracking-wide mb-1">Outil gratuit · sans inscription</p>
            <h3 className="font-display text-2xl font-semibold text-brand-greenDeep">Calculez la révision de loyer avec l'IRL</h3>
            <p className="text-brand-green/60 text-sm mt-1">Obtenez le nouveau loyer en un instant à partir de l'indice de référence des loyers.</p>
          </div>
          <Link
            to="/revision-loyer-irl/calculateur"
            className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold transition-colors flex-shrink-0"
            data-testid="home-irl-cta"
          >
            Calculer ma révision
            <Icons.ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
}
